/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Contract_ManagedInputs */



/**
* | output |
* | --- |
* | "Your partner manages your plan, seats and add-ons as part of your contract. Contact them to change anything." |
*
* @param {Sub_Contract_ManagedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_contract_managed = /** @type {((inputs?: Sub_Contract_ManagedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Contract_ManagedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ihr Partner verwaltet Tarif, Plätze und Add-ons als Teil Ihres Vertrags. Wenden Sie sich an ihn, um etwas zu ändern.")
	return /** @type {LocalizedString} */ ("Your partner manages your plan, seats and add-ons as part of your contract. Contact them to change anything.")
});